"use client";
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { Config } from "./schema";

const clientConfigContext = createContext<Config | undefined>(undefined);

export const useConfig = () => useContext(clientConfigContext);
export const ClientConfigProvider = ({
  children,
  config,
}: {
  children: ReactNode;
  config: Config;
}) => (
  <clientConfigContext.Provider value={config}>
    {children}
  </clientConfigContext.Provider>
);
